import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { Reveal, LineReveal } from "./anim";
import { CONTACT } from "./config";
import { openReservation } from "./ReservationDialog";

const Footer = () => (
  <footer id="contact" data-testid="footer-section" className="relative bg-ink pt-28 lg:pt-40">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="mb-6 text-xs uppercase tracking-[0.3em] text-rose">Réservation</p>
        <h2 className="font-serif text-5xl leading-[0.95] tracking-tight sm:text-7xl lg:text-8xl text-blush">
          <LineReveal lines={["Prêt à réserver", "votre trajet ?"]} />
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-wrap items-center gap-4">
          <button data-testid="footer-whatsapp-cta" onClick={openReservation}
            className="group inline-flex items-center gap-3 rounded-full bg-blush px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-ink transition-transform hover:scale-[1.04]">
            <FaWhatsapp size={18} /> Réserver sur WhatsApp
          </button>
          <a data-testid="footer-call-cta" href={CONTACT.phoneHref}
            className="inline-flex items-center gap-3 rounded-full border border-rose/50 px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-rose transition-colors hover:bg-rose/10">
            <Phone size={16} /> Appeler maintenant
          </a>
        </div>
      </Reveal>

      <div className="mt-24 grid grid-cols-1 gap-10 border-t border-white/10 py-14 sm:grid-cols-2 lg:grid-cols-4">
        {[
          { icon: Phone, label: "Téléphone", value: CONTACT.phoneDisplay, href: CONTACT.phoneHref, testid: "contact-phone" },
          { icon: Mail, label: "Email", value: CONTACT.email, href: CONTACT.emailHref, testid: "contact-email" },
          { icon: MapPin, label: "Zone", value: CONTACT.zone, testid: "contact-zone" },
          { icon: Clock, label: "Disponibilité", value: CONTACT.hours, testid: "contact-hours" },
        ].map((item) => (
          <div key={item.label} data-testid={item.testid}>
            <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full border border-rose/40 text-rose">
              <item.icon size={16} />
            </div>
            <p className="mb-1 text-xs uppercase tracking-[0.18em] text-muted-foreground">{item.label}</p>
            {item.href ? (
              <a href={item.href} className="text-lg text-blush hover:text-blush-300 transition-colors">{item.value}</a>
            ) : (
              <p className="text-lg text-blush">{item.value}</p>
            )}
          </div>
        ))}
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 sm:flex-row">
        <div className="flex items-baseline gap-2">
          <span className="font-serif text-2xl tracking-tight text-blush">MN</span>
          <span className="text-[0.6rem] tracking-[0.4em] text-rose">VTC</span>
        </div>
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} MN VTC — {CONTACT.tagline}.</p>
        <p className="text-xs text-muted-foreground">Voiture de Transport avec Chauffeur</p>
      </div>
    </div>
  </footer>
);

export default Footer;
